/**
 * Referentiel des departements francais.
 * `lat`/`lon` sont des centroides approximatifs : ils servent uniquement au
 * rendu de la carte de repartition du tableau de bord (cahier des charges 3.4),
 * pas a du geocodage.
 */
export interface Departement {
  code: string;
  nom: string;
  region: string;
  lat: number;
  lon: number;
  /** Departement d'outre-mer : projete separement sur la carte. */
  outreMer: boolean;
}

export const DEPARTEMENTS: readonly Departement[] = [
  { code: '01', nom: 'Ain', region: 'Auvergne-Rhône-Alpes', lat: 46.1, lon: 5.35, outreMer: false },
  { code: '02', nom: 'Aisne', region: 'Hauts-de-France', lat: 49.55, lon: 3.55, outreMer: false },
  { code: '03', nom: 'Allier', region: 'Auvergne-Rhône-Alpes', lat: 46.4, lon: 3.2, outreMer: false },
  { code: '04', nom: 'Alpes-de-Haute-Provence', region: "Provence-Alpes-Côte d'Azur", lat: 44.1, lon: 6.25, outreMer: false },
  { code: '05', nom: 'Hautes-Alpes', region: "Provence-Alpes-Côte d'Azur", lat: 44.66, lon: 6.3, outreMer: false },
  { code: '06', nom: 'Alpes-Maritimes', region: "Provence-Alpes-Côte d'Azur", lat: 43.94, lon: 7.12, outreMer: false },
  { code: '07', nom: 'Ardèche', region: 'Auvergne-Rhône-Alpes', lat: 44.75, lon: 4.42, outreMer: false },
  { code: '08', nom: 'Ardennes', region: 'Grand Est', lat: 49.63, lon: 4.65, outreMer: false },
  { code: '09', nom: 'Ariège', region: 'Occitanie', lat: 42.94, lon: 1.5, outreMer: false },
  { code: '10', nom: 'Aube', region: 'Grand Est', lat: 48.3, lon: 4.17, outreMer: false },
  { code: '11', nom: 'Aude', region: 'Occitanie', lat: 43.1, lon: 2.42, outreMer: false },
  { code: '12', nom: 'Aveyron', region: 'Occitanie', lat: 44.3, lon: 2.66, outreMer: false },
  { code: '13', nom: 'Bouches-du-Rhône', region: "Provence-Alpes-Côte d'Azur", lat: 43.5, lon: 5.1, outreMer: false },
  { code: '14', nom: 'Calvados', region: 'Normandie', lat: 49.1, lon: -0.36, outreMer: false },
  { code: '15', nom: 'Cantal', region: 'Auvergne-Rhône-Alpes', lat: 45.05, lon: 2.65, outreMer: false },
  { code: '16', nom: 'Charente', region: 'Nouvelle-Aquitaine', lat: 45.72, lon: 0.2, outreMer: false },
  { code: '17', nom: 'Charente-Maritime', region: 'Nouvelle-Aquitaine', lat: 45.75, lon: -0.8, outreMer: false },
  { code: '18', nom: 'Cher', region: 'Centre-Val de Loire', lat: 47.07, lon: 2.5, outreMer: false },
  { code: '19', nom: 'Corrèze', region: 'Nouvelle-Aquitaine', lat: 45.35, lon: 1.87, outreMer: false },
  { code: '21', nom: "Côte-d'Or", region: 'Bourgogne-Franche-Comté', lat: 47.4, lon: 4.8, outreMer: false },
  { code: '22', nom: "Côtes-d'Armor", region: 'Bretagne', lat: 48.45, lon: -2.85, outreMer: false },
  { code: '23', nom: 'Creuse', region: 'Nouvelle-Aquitaine', lat: 46.1, lon: 2.03, outreMer: false },
  { code: '24', nom: 'Dordogne', region: 'Nouvelle-Aquitaine', lat: 45.1, lon: 0.75, outreMer: false },
  { code: '25', nom: 'Doubs', region: 'Bourgogne-Franche-Comté', lat: 47.17, lon: 6.35, outreMer: false },
  { code: '26', nom: 'Drôme', region: 'Auvergne-Rhône-Alpes', lat: 44.68, lon: 5.15, outreMer: false },
  { code: '27', nom: 'Eure', region: 'Normandie', lat: 49.13, lon: 0.98, outreMer: false },
  { code: '28', nom: 'Eure-et-Loir', region: 'Centre-Val de Loire', lat: 48.45, lon: 1.35, outreMer: false },
  { code: '29', nom: 'Finistère', region: 'Bretagne', lat: 48.25, lon: -4.1, outreMer: false },
  { code: '2A', nom: 'Corse-du-Sud', region: 'Corse', lat: 41.86, lon: 8.98, outreMer: false },
  { code: '2B', nom: 'Haute-Corse', region: 'Corse', lat: 42.4, lon: 9.2, outreMer: false },
  { code: '30', nom: 'Gard', region: 'Occitanie', lat: 43.98, lon: 4.2, outreMer: false },
  { code: '31', nom: 'Haute-Garonne', region: 'Occitanie', lat: 43.4, lon: 1.2, outreMer: false },
  { code: '32', nom: 'Gers', region: 'Occitanie', lat: 43.68, lon: 0.45, outreMer: false },
  { code: '33', nom: 'Gironde', region: 'Nouvelle-Aquitaine', lat: 44.8, lon: -0.55, outreMer: false },
  { code: '34', nom: 'Hérault', region: 'Occitanie', lat: 43.6, lon: 3.35, outreMer: false },
  { code: '35', nom: 'Ille-et-Vilaine', region: 'Bretagne', lat: 48.15, lon: -1.6, outreMer: false },
  { code: '36', nom: 'Indre', region: 'Centre-Val de Loire', lat: 46.8, lon: 1.55, outreMer: false },
  { code: '37', nom: 'Indre-et-Loire', region: 'Centre-Val de Loire', lat: 47.25, lon: 0.7, outreMer: false },
  { code: '38', nom: 'Isère', region: 'Auvergne-Rhône-Alpes', lat: 45.25, lon: 5.6, outreMer: false },
  { code: '39', nom: 'Jura', region: 'Bourgogne-Franche-Comté', lat: 46.7, lon: 5.75, outreMer: false },
  { code: '40', nom: 'Landes', region: 'Nouvelle-Aquitaine', lat: 43.95, lon: -0.75, outreMer: false },
  { code: '41', nom: 'Loir-et-Cher', region: 'Centre-Val de Loire', lat: 47.6, lon: 1.4, outreMer: false },
  { code: '42', nom: 'Loire', region: 'Auvergne-Rhône-Alpes', lat: 45.7, lon: 4.2, outreMer: false },
  { code: '43', nom: 'Haute-Loire', region: 'Auvergne-Rhône-Alpes', lat: 45.1, lon: 3.8, outreMer: false },
  { code: '44', nom: 'Loire-Atlantique', region: 'Pays de la Loire', lat: 47.35, lon: -1.65, outreMer: false },
  { code: '45', nom: 'Loiret', region: 'Centre-Val de Loire', lat: 47.9, lon: 2.35, outreMer: false },
  { code: '46', nom: 'Lot', region: 'Occitanie', lat: 44.65, lon: 1.6, outreMer: false },
  { code: '47', nom: 'Lot-et-Garonne', region: 'Nouvelle-Aquitaine', lat: 44.35, lon: 0.5, outreMer: false },
  { code: '48', nom: 'Lozère', region: 'Occitanie', lat: 44.52, lon: 3.5, outreMer: false },
  { code: '49', nom: 'Maine-et-Loire', region: 'Pays de la Loire', lat: 47.4, lon: -0.55, outreMer: false },
  { code: '50', nom: 'Manche', region: 'Normandie', lat: 49.1, lon: -1.3, outreMer: false },
  { code: '51', nom: 'Marne', region: 'Grand Est', lat: 48.95, lon: 4.35, outreMer: false },
  { code: '52', nom: 'Haute-Marne', region: 'Grand Est', lat: 48.1, lon: 5.2, outreMer: false },
  { code: '53', nom: 'Mayenne', region: 'Pays de la Loire', lat: 48.15, lon: -0.65, outreMer: false },
  { code: '54', nom: 'Meurthe-et-Moselle', region: 'Grand Est', lat: 48.75, lon: 6.15, outreMer: false },
  { code: '55', nom: 'Meuse', region: 'Grand Est', lat: 49.0, lon: 5.4, outreMer: false },
  { code: '56', nom: 'Morbihan', region: 'Bretagne', lat: 47.85, lon: -2.8, outreMer: false },
  { code: '57', nom: 'Moselle', region: 'Grand Est', lat: 49.05, lon: 6.65, outreMer: false },
  { code: '58', nom: 'Nièvre', region: 'Bourgogne-Franche-Comté', lat: 47.1, lon: 3.55, outreMer: false },
  { code: '59', nom: 'Nord', region: 'Hauts-de-France', lat: 50.45, lon: 3.25, outreMer: false },
  { code: '60', nom: 'Oise', region: 'Hauts-de-France', lat: 49.4, lon: 2.4, outreMer: false },
  { code: '61', nom: 'Orne', region: 'Normandie', lat: 48.6, lon: 0.1, outreMer: false },
  { code: '62', nom: 'Pas-de-Calais', region: 'Hauts-de-France', lat: 50.5, lon: 2.3, outreMer: false },
  { code: '63', nom: 'Puy-de-Dôme', region: 'Auvergne-Rhône-Alpes', lat: 45.72, lon: 3.15, outreMer: false },
  { code: '64', nom: 'Pyrénées-Atlantiques', region: 'Nouvelle-Aquitaine', lat: 43.3, lon: -0.8, outreMer: false },
  { code: '65', nom: 'Hautes-Pyrénées', region: 'Occitanie', lat: 43.05, lon: 0.15, outreMer: false },
  { code: '66', nom: 'Pyrénées-Orientales', region: 'Occitanie', lat: 42.6, lon: 2.5, outreMer: false },
  { code: '67', nom: 'Bas-Rhin', region: 'Grand Est', lat: 48.65, lon: 7.6, outreMer: false },
  { code: '68', nom: 'Haut-Rhin', region: 'Grand Est', lat: 47.85, lon: 7.25, outreMer: false },
  { code: '69', nom: 'Rhône', region: 'Auvergne-Rhône-Alpes', lat: 45.87, lon: 4.6, outreMer: false },
  { code: '70', nom: 'Haute-Saône', region: 'Bourgogne-Franche-Comté', lat: 47.65, lon: 6.1, outreMer: false },
  { code: '71', nom: 'Saône-et-Loire', region: 'Bourgogne-Franche-Comté', lat: 46.65, lon: 4.55, outreMer: false },
  { code: '72', nom: 'Sarthe', region: 'Pays de la Loire', lat: 48.0, lon: 0.2, outreMer: false },
  { code: '73', nom: 'Savoie', region: 'Auvergne-Rhône-Alpes', lat: 45.5, lon: 6.45, outreMer: false },
  { code: '74', nom: 'Haute-Savoie', region: 'Auvergne-Rhône-Alpes', lat: 46.0, lon: 6.45, outreMer: false },
  { code: '75', nom: 'Paris', region: 'Île-de-France', lat: 48.86, lon: 2.35, outreMer: false },
  { code: '76', nom: 'Seine-Maritime', region: 'Normandie', lat: 49.65, lon: 1.0, outreMer: false },
  { code: '77', nom: 'Seine-et-Marne', region: 'Île-de-France', lat: 48.62, lon: 2.95, outreMer: false },
  { code: '78', nom: 'Yvelines', region: 'Île-de-France', lat: 48.82, lon: 1.85, outreMer: false },
  { code: '79', nom: 'Deux-Sèvres', region: 'Nouvelle-Aquitaine', lat: 46.55, lon: -0.35, outreMer: false },
  { code: '80', nom: 'Somme', region: 'Hauts-de-France', lat: 49.95, lon: 2.3, outreMer: false },
  { code: '81', nom: 'Tarn', region: 'Occitanie', lat: 43.8, lon: 2.2, outreMer: false },
  { code: '82', nom: 'Tarn-et-Garonne', region: 'Occitanie', lat: 44.05, lon: 1.28, outreMer: false },
  { code: '83', nom: 'Var', region: "Provence-Alpes-Côte d'Azur", lat: 43.45, lon: 6.2, outreMer: false },
  { code: '84', nom: 'Vaucluse', region: "Provence-Alpes-Côte d'Azur", lat: 44.0, lon: 5.15, outreMer: false },
  { code: '85', nom: 'Vendée', region: 'Pays de la Loire', lat: 46.65, lon: -1.2, outreMer: false },
  { code: '86', nom: 'Vienne', region: 'Nouvelle-Aquitaine', lat: 46.55, lon: 0.45, outreMer: false },
  { code: '87', nom: 'Haute-Vienne', region: 'Nouvelle-Aquitaine', lat: 45.9, lon: 1.25, outreMer: false },
  { code: '88', nom: 'Vosges', region: 'Grand Est', lat: 48.2, lon: 6.4, outreMer: false },
  { code: '89', nom: 'Yonne', region: 'Bourgogne-Franche-Comté', lat: 47.85, lon: 3.55, outreMer: false },
  { code: '90', nom: 'Territoire de Belfort', region: 'Bourgogne-Franche-Comté', lat: 47.63, lon: 6.9, outreMer: false },
  { code: '91', nom: 'Essonne', region: 'Île-de-France', lat: 48.52, lon: 2.25, outreMer: false },
  { code: '92', nom: 'Hauts-de-Seine', region: 'Île-de-France', lat: 48.84, lon: 2.24, outreMer: false },
  { code: '93', nom: 'Seine-Saint-Denis', region: 'Île-de-France', lat: 48.92, lon: 2.48, outreMer: false },
  { code: '94', nom: 'Val-de-Marne', region: 'Île-de-France', lat: 48.78, lon: 2.47, outreMer: false },
  { code: '95', nom: "Val-d'Oise", region: 'Île-de-France', lat: 49.08, lon: 2.13, outreMer: false },
  { code: '971', nom: 'Guadeloupe', region: 'Guadeloupe', lat: 16.25, lon: -61.55, outreMer: true },
  { code: '972', nom: 'Martinique', region: 'Martinique', lat: 14.64, lon: -61.02, outreMer: true },
  { code: '973', nom: 'Guyane', region: 'Guyane', lat: 4.0, lon: -53.0, outreMer: true },
  { code: '974', nom: 'La Réunion', region: 'La Réunion', lat: -21.13, lon: 55.53, outreMer: true },
  { code: '976', nom: 'Mayotte', region: 'Mayotte', lat: -12.83, lon: 45.15, outreMer: true },
] as const;

const INDEX_DEPARTEMENTS = new Map(DEPARTEMENTS.map((d) => [d.code, d]));

export function departementParCode(code: string | null | undefined): Departement | undefined {
  if (!code) return undefined;
  return INDEX_DEPARTEMENTS.get(code.toUpperCase());
}

export function nomDepartement(code: string | null | undefined): string {
  return departementParCode(code)?.nom ?? code ?? 'Inconnu';
}

/**
 * Deduit le code departement d'un code postal.
 * Gere la Corse (20xxx -> 2A/2B) et l'outre-mer (97x).
 */
export function departementDepuisCodePostal(codePostal: string | null | undefined): string | null {
  if (!codePostal) return null;
  const cp = codePostal.trim();
  if (!/^\d{5}$/.test(cp)) return null;
  if (cp.startsWith('97') || cp.startsWith('98')) return cp.slice(0, 3);
  if (cp.startsWith('20')) {
    // La Poste a reparti la Corse de part et d'autre de 20200 : les codes
    // 20000-20199 relevent de la Corse-du-Sud, 20200-20999 de la Haute-Corse
    // (Bastia 20200, Corte 20250, Furiani 20600).
    return Number.parseInt(cp, 10) < 20200 ? '2A' : '2B';
  }
  return cp.slice(0, 2);
}

export const REGIONS: readonly string[] = Array.from(
  new Set(DEPARTEMENTS.map((d) => d.region)),
).sort();
